"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSCarePackageCategory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSCarePackage_1 = require("./NHSCarePackage");
var NHSCategory_1 = require("./NHSCategory");
var NHSCarePackageCategory_Factory = /** @class */ (function () {
    function NHSCarePackageCategory_Factory() {
    }
    NHSCarePackageCategory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ActiveFrom: Date_Factory_1.Date_Factory.CreateIncoming(model.ActiveFrom),
            ActiveTo: Date_Factory_1.Date_Factory.CreateIncoming(model.ActiveTo),
            CarePackageId: model.CarePackageId,
            NHSCarePackage: NHSCarePackage_1.NHSCarePackage_Factory.CreateIncoming(model.NHSCarePackage),
            NHSCategory: NHSCategory_1.NHSCategory_Factory.CreateIncoming(model.NHSCategory),
            NHSCategoryId: model.NHSCategoryId,
            RecordId: model.RecordId,
        };
        return result;
    };
    NHSCarePackageCategory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ActiveFrom: Date_Factory_1.Date_Factory.CreateOutgoing(model.ActiveFrom),
            ActiveTo: Date_Factory_1.Date_Factory.CreateOutgoing(model.ActiveTo),
            CarePackageId: model.CarePackageId,
            NHSCarePackage: NHSCarePackage_1.NHSCarePackage_Factory.CreateOutgoing(model.NHSCarePackage),
            NHSCategory: NHSCategory_1.NHSCategory_Factory.CreateOutgoing(model.NHSCategory),
            NHSCategoryId: model.NHSCategoryId,
            RecordId: model.RecordId,
        };
        return result;
    };
    return NHSCarePackageCategory_Factory;
}());
exports.NHSCarePackageCategory_Factory = NHSCarePackageCategory_Factory;
